import React, { Component } from "react"
import {FaAngleLeft,FaAngleRight} from "react-icons/all"
import Card from "./Card"
import data from "../data/Data"

class Projects extends Component {
    constructor(props) {
        super(props);
        this.state = {
            properties: data.properties,
            property: data.properties[1]
        }
    }

    prevBtn = () => {
        const newIndex = this.state.property.index-1;
        if (newIndex >= 0) {
            this.setState ({
                property: data.properties[newIndex]
            })
        } else {
            this.setState ({
                property: data.properties[data.properties.length-1]
            })
        }
        console.log(newIndex);
    }

    nextBtn = () => {
        const newIndex = this.state.property.index+1;
        if (newIndex <= data.properties.length-1) {
            this.setState ({
                property: data.properties[newIndex]
            })
        } else {
            this.setState ({
                property: data.properties[0]
            })
        }
        
    }
    render() {
        const {properties, property} = this.state;
        return (
            <div id="projects">
                <h1>Featured Projects</h1>
                <h3>Take a look at what I've done so far</h3>
                <div className="circle-left circle" onClick={() => this.prevBtn()}><FaAngleLeft/></div>
                <div className="circle-right circle" onClick={() => this.nextBtn()}><FaAngleRight/></div>
                <div className="wrapper">
                    <div className={`work-showcase active-slide-${property.index}`}>
                        <div className="slider-wrapper" style={{
                            "transform":`translateX(-${property.index*(100/properties.length)}%)`
                        }}>
                            {properties.map( property =>  <Card key = {property.index} property={property}/>)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Projects;